import React from "react"
export function Profile(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10 2a8 8 0 110 16 8 8 0 010-16zm0 1.5a6.5 6.5 0 00-4.171 11.485 4.57 4.57 0 018.342 0A6.5 6.5 0 0010 3.5zm0 1.929a2.857 2.857 0 110 5.714 2.857 2.857 0 010-5.714z"
        fill="currentColor"
        id="prefix__profile"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
